<template>
<!-- 企业管理-创建企业-查看企业门店 -->

    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="80%" :before-close="closeDialog">
        <div style="text-align: center; margin-bottom: 20px; font-size: 20px">{{ name }}</div>

        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="name" label="门店" min-width="140"> </el-table-column>

            <el-table-column prop="admin_name" label="姓名" min-width="100"> </el-table-column>

            <el-table-column prop="phone" label="电话" min-width="100"> </el-table-column>

            <el-table-column prop="created_at" label="添加日期" min-width="160"> </el-table-column>
            <el-table-column prop="type" label="类型" min-width="160"> </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
let _this;
export default {
    props: {
        isShow: Boolean,
        data: '',
        name: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data.store_code = _this.data;
        
            _this.storeAdminLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,

            search_data: {
                page: 1,
                limit: 10,
                store_code: ''
            },

            tableData: [],
            result_data: {}
        };
    },
    methods: {
        closeDialog() {
            _this.show = false;
       
        },
        storeAdminLists() {
            _this.$post('/store/storeAdminLists', _this.search_data).then((res) => {
                _this.result_data = res;
                _this.tableData = res.data;
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.storeAdminLists();
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
</style>
